import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupA2 } from "../../../../../redux/app/orb3/groups/group-a";
import ORB3TableRows, { renderDataTable } from "../ORB3TableRows";

const ODS_COLUMNS = [
	{ key: "equipment", label: "Equipment" },
	{ key: "substance", label: "Substance" },
];

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupA2PreviewProps = OwnProps;

function ORB3GroupA2Preview(props: ORB3GroupA2PreviewProps) {
	const record = props.orb3Record as TORB3GroupA2;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const { itemA2 } = record;

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[
						operationDate,
						"3-A",
						"1.2",
						`Operation Type: ${itemA2.operationType}`,
					],
					[null, null, "-", `Operation Info: ${itemA2.operationInfo}`],
					[
						null,
						null,
						"-",
						`Vessel Position: ${itemA2.vesselPosition.latitude} / ${itemA2.vesselPosition.longitude}`,
					],
					[null, null, "-", renderDataTable(itemA2.items, ODS_COLUMNS)],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupA2Preview;
